import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { try { console.error('[UI hata]', error, info && info.componentStack); } catch (e) {} }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'var(--bg, #1A1F2E)', color: '#F0F2F5', fontFamily: 'Inter, -apple-system, sans-serif' }}>
        <div style={{ width: 'min(100%, 420px)', background: '#252D3D', border: '1px solid #3A4460', borderRadius: 16, padding: 24, textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>⚠️</div>
          <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 6 }}>Sayfa yüklenirken bir hata oluştu</div>
          <div style={{ fontSize: 12, color: '#B8C0D4', background: '#1E2433', borderRadius: 8, padding: '8px 10px', margin: '12px 0 16px', wordBreak: 'break-word', textAlign: 'left', fontFamily: 'monospace' }}>
            {String((error && error.message) || error)}
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => window.location.reload()} style={{ background: '#00B4B4', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontWeight: 600, cursor: 'pointer' }}>Yenile</button>
            <button onClick={() => { this.setState({ error: null }); window.location.href = '/'; }} style={{ background: 'transparent', color: '#B8C0D4', border: '1px solid #3A4460', borderRadius: 8, padding: '10px 18px', fontWeight: 600, cursor: 'pointer' }}>Ana sayfa</button>
            <button onClick={() => { localStorage.clear(); window.location.href = '/login'; }} style={{ background: 'transparent', color: '#EF4444', border: '1px solid rgba(239,68,68,.35)', borderRadius: 8, padding: '10px 18px', fontWeight: 600, cursor: 'pointer' }}>Çıkış yap</button>
          </div>
        </div>
      </div>
    );
  }
}
